module.exports = __webpack_public_path__ + "static/media/enterpriseservicestwo.a1a1bc12.png";